export default __webpack_public_path__ + "static/media/751.1d8956de.png";